var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBurgerOpen = function SvgBurgerOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.152 2.786H29.57M3.152 10.71H29.57M3.152 18.635H29.57",
    stroke: "#F2E8E1",
    strokeWidth: 5.443,
    strokeLinecap: "round"
  })));
};
export { SvgBurgerOpen as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMzMiCiAgaGVpZ2h0PSIyMiIKICB2aWV3Qm94PSIwIDAgMzMgMjIiCiAgZmlsbD0ibm9uZSIKPgogIDxwYXRoCiAgICBkPSJNMy4xNTIzNCAyLjc4NjEzSDI5LjU2ODYiCiAgICBzdHJva2U9IiNGMkU4RTEiCiAgICBzdHJva2Utd2lkdGg9IjUuNDQzMTMiCiAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgLz4KICA8cGF0aAogICAgZD0iTTMuMTUyMzQgMTAuNzFIMjkuNTY4NiIKICAgIHN0cm9rZT0iI0YyRThFMSIKICAgIHN0cm9rZS13aWR0aD0iNS40NDMxMyIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAvPgogIDxwYXRoCiAgICBkPSJNMy4xNTIzNCAxOC42MzQ4SDI5LjU2ODYiCiAgICBzdHJva2U9IiNGMkU4RTEiCiAgICBzdHJva2Utd2lkdGg9IjUuNDQzMTMiCiAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgLz4KPC9zdmc+";